<template>
	<div class="pages">
		<z-table :offset="params.offset" :count="params.count" :total-count="list.item_total" @handleOffset="handleOffset">
			<th slot="columns" v-for="item in columns">{{item}}</th>
			<tr slot="datasource" v-for="(item, index) in list.list || []">
				<td>{{item.type == 1 ? '客服消息群发':'群发接口群发'}}</td>
				<td>{{item.mass_type | filterMaterialType}}</td>
				<td>{{item.type == 1 ? item.success_num:'全部'}}</td>
				<td>{{item.fail_num}}</td>
				<td>{{item.c_time | momentFmt}}</td>
				<!--<td>{{item.status == 0 ? '发送中...':'发送成功' }}</td>-->
				<td :class="[item.status == 0?'ing':'success']">{{item.status == 0 ? '发送中...':'发送成功' }}</td>
				<!--<td class="operating">
					<a @click="handleDeleteSendMass(item.id)" class="operat-btn"><i class="icon-del"></i><span>删除</span></a>
				</td>-->
			</tr>
			<!--<tr slot="datasource" v-show="list.list.length <=0">
				<td colspan="20" ><p class="p-20">暂无群发消息数据！</p></td>
			</tr>-->
		</z-table>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	export default {
		name: 'List',
		data() {
			return {
				columns :['群发类型','消息类型','成功人数','失败人数','发送时间','发送状态'],
				params:{
					offset:0,//分页偏移量
					count:10 //每页多少条
				}
			}
		},
		props: {//接收父组件数据
		},
		/*
		 * 属性计算
		 */
		computed: {
			...mapState({
				list: state => state.mass.list
			})
		},
		/*
		 * 事件处理
		 */
		methods: {
			handleOffset(offset){
				this.params.offset = offset
				this.handleGetMass()
			},
//			handleDeleteSendMass(id=null){//删除群发记录
//				this.$confirm(`确定要删除此条群发记录?`).then(action => {
//					let params ={
//						id : id
//					}
//					this.deleteMass(params).then((data)=>{
//						this.handleGetMass()
//						this.$success('删除成功')
//						
//					},(msg)=>{
//						this.$success(msg)
//					})
//				},()=>{});
//				
//			},
			handleGetMass(){
				this.getMass(this.params)
			},
			...mapActions(['getMass','deleteMass']),
		}
	}
</script>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	td {
		&.success {
			color: $color-success;
		}
		&.ing {
			color: $color-warning;
		}
		&.fail {
			color: $color-wrong;
		}
	}
</style>


// WEBPACK FOOTER //
// WxMassList.vue?fa75c1a8